import PropTypes from 'prop-types';
import {
  getPaymentEmpaque,
  shouldShowPaymentEmpaque,
} from 'utils/paymentSummaryEmpaque';

const PaymentResumeEmpaqueRow = ({ payment, label }) => {
  if (!shouldShowPaymentEmpaque(payment)) {
    return null;
  }

  return (
    <div className='flex justify-between payment-resume-empaque-row mt-2'>
      <h2 className='font-bold'>{label}</h2>
      <h3 className='text-neutral-500 text-right'>{getPaymentEmpaque(payment)}</h3>
    </div>
  );
};

PaymentResumeEmpaqueRow.propTypes = {
  payment: PropTypes.object,
  label: PropTypes.string.isRequired,
};

export default PaymentResumeEmpaqueRow;
